module.exports = __webpack_public_path__ + "static/media/money-bill-duotone.be484cf6.svg";